import styled from "styled-components";
import { NavLink } from 'react-router-dom';
import ArrowDownIcon from 'components/ArrowDownIcon';

const Link = styled(NavLink)`
  font-family: 'Khula', sans-serif;
  font-weight: 400;
  color: white;
  margin: 0px 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  font-size: 19px;
  font-stretch: condensed;
  &:hover{
    color: white;
    opacity: 0.8;
  }
`;

const ContainerSubtotal = styled.div`
  font-family: 'Khula', sans-serif;
  font-weight: 400;
  color: white;
  margin: 0px 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  font-size: 19px;
  font-stretch: condensed;
  cursor: pointer;
  &:first-child{
    opacity: 0.8;
  }
  &>svg{
    width: 20px;
    margin-bottom: 10px;
    margin-right: 6px;
    opacity: 0.8;
  }
  &:hover{
    &:first-child{
      color: white;
      opacity: 1;
    }
    &>svg{
      opacity: 1;
  }

  }
`;



const LinkButton = styled.div`
  font-family: 'Khula', sans-serif;
  font-weight: 400;
  color: white;
  margin: 0px 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  font-size: 19px;
  font-stretch: condensed;
  cursor: pointer;
  &:hover{
    color: white;
    opacity: 0.8;
  }
  @media screen and (max-width: 992px) {
    display: none;
  }
`;

const LinkRegular = styled.a`
  font-family: 'Khula', sans-serif !important;
  font-weight: 400;
  color: white;
  margin: 0px 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  font-size: 19px;
  font-stretch: condensed;
  cursor: pointer;
  &:hover{
    opacity: 0.8;
    color: white;
  }
`;


const LogoLink = styled(NavLink)`
  @media screen and (max-width: 992px) {
    position: absolute;
    left: 100px;
  }
`;

const Nav = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  z-index: 101;
  height: 100%;
`;

const Menu = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: row;
  list-style-type: none;
  justify-content: flex-end;
  height: 100%;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
`;

const Logo = styled.img`
  width: 100%;
  max-width: 50px;
  margin-top: 8px;
`;

const ArrowDownContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  margin-left: 10px;
  ${({ open }) => open && `transform: rotate(180deg);`}
  transition: transform 0.6s;
`;

const ArrowDown = styled(ArrowDownIcon)`
  width: 20px;
  height: 20px;
`;

const ContainerSubtotalAmount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

export default {
  Link,
  LinkRegular,
  LogoLink,
  Logo,
  Nav,
  Menu,
  LinkButton,
  ArrowDown,
  ArrowDownContainer,
  ContainerSubtotal,
  ContainerSubtotalAmount,
}
